<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <!-- <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">ข้อมูลนำเข้า</v-card-title> -->
      <v-row>
        <v-col :cols="IpadSize || MobileSize ? 12 : 6" clss="pb-0">
          <v-card-title class="px-0" style="font-weight: bold;  font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">
            <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายละเอียดลูกค้า
          </v-card-title>
          <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
            <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายละเอียดลูกค้า
          </v-card-title>
        </v-col>
        <v-col :cols="IpadSize || MobileSize ? 12 : 6" align="end" :class="IpadSize || MobileSize ? 'pt-0 px-6' : IpadProSize ? 'mt-3 pb-0 px-6' : 'mt-3 pb-0 px-6'">
          <v-btn color="#27AB9C" dark class="mr-2" outlined @click="confirmDelete()"><v-icon left color="#27AB9C" size="20">mdi-trash-can-outline</v-icon>ลบ</v-btn>
          <v-btn color="#27AB9C" dark outlined @click="editCustomer()"><v-icon left color="#27AB9C" size="20">mdi-pencil-outline</v-icon>แก้ไข</v-btn>
        </v-col>
      </v-row>
      <v-card-text :class="IpadSize || IpadProSize || MobileSize ? 'px-0' : ''">
        <v-row no-gutters class="ml-4 mr-3" v-if="customerDetail">
          <v-col :cols="IpadSize || MobileSize ? 12 : 6" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">รหัสลูกค้า : <span class="text-value">{{ customerDetail.cus_code }}</span></span>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 6" :align="IpadSize || MobileSize ? 'left' : 'right'" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">วันที่เพิ่มข้อมูล : <span class="text-value">{{ formatDateTH(customerDetail.created_at) }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">ชื่อลูกค้า : <span class="text-value">{{ customerDetail.cus_name }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">เบอร์ติดต่อ : <span class="text-value">{{ customerDetail.cus_tel }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">กลุ่มลูกค้า : <span class="text-value">{{ customerDetail.channel_name }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">หมายเหตุ : <span class="text-value">{{ customerDetail.note }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">รหัสฝ่ายขาย : <span class="text-value">{{ customerDetail.sales_code }}</span></span>
          </v-col>
          <v-col cols="12" align="left" class="mb-4">
            <span :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeDetailMobile' : 'fontSizeDetail'">ชื่อฝ่ายขาย : <span class="text-value">{{ customerDetail.sales_name }}</span></span>
          </v-col>
        </v-row>
        <v-row no-gutters class="mx-4 mt-4">
          <v-col cols="12">
            <p :class="IpadSize || IpadProSize || MobileSize ? 'fontSizeTitleMobile': 'fontSizeTitle'" style="font-weight: 700;">ที่อยู่จัดส่ง</p>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 6" class="pt-2">
            <p style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">แสดงรายการที่อยู่ {{ addressList.length }} รายการ จากทั้งหมด {{ totalAddress }} รายการ</p>
          </v-col>
          <v-col :cols="IpadSize || MobileSize ? 12 : 6" align="end" :class="IpadSize || MobileSize ? 'mb-4' : ''">
            <v-btn color="#27AB9C" dark @click="addAddress()"><v-icon>mdi-plus</v-icon> เพิ่มที่อยู่จัดส่ง</v-btn>
          </v-col>
          <v-col v-if="addressList.length === 0" align="center" justify="center" class="pt-7">
            <span class="font16_msgNoAddress">
              หากไม่มีข้อมูลที่อยู่จัดส่ง จะไม่สามารถสร้างรายการสั่งซื้อได้
            </span>
          </v-col>
          <v-col v-else class="px-0">
            <v-col cols="12" md="12" sm="12" xs="12" v-for="(item, index) in addressList" :key="index" class="mb-4 px-0">
              <v-card width="100%" height="100%" min-height="144" outlined style="background: #FFFFFF; border: 1px solid #5BC3A2; border-radius: 8px;">
                <v-card-text class="px-1">
                  <v-container fill-height fluid>
                    <v-row>
                      <v-col cols="6" class="pt-1">
                        <span style="font-size: 18px; line-height: 26px; color: #333333; font-weight: 700;">
                          Ship To {{ index + 1 + ((pageNumber - 1) * 5) }}
                        </span>
                      </v-col>
                      <v-col cols="6" align="end" class="py-0">
                        <v-btn color="#27AB9C" icon dark class="mr-2"  @click="confirmDeleteAddress(item)"><v-icon  color="#27AB9C" size="20">mdi-trash-can-outline</v-icon></v-btn>
                        <v-btn color="#27AB9C" icon dark @click="editAddress(item)"><v-icon color="#27AB9C" size="20">mdi-pencil-outline</v-icon></v-btn>
                      </v-col>
                      <v-col cols="12">
                        <div v-if="MobileSize" style="font-size: 14px; line-height: 26px; color: #333333; display: flex; align-items: center;">
                          {{ item.address }}
                        </div>
                        <div v-else style="font-size: 16px; line-height: 26px; color: #333333; display: flex; align-items: center;">
                          {{ item.address }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-col>
        </v-row>
        <v-row justify="center" class="mx-4 my-6" v-if="totalAddress !== 0">
          <v-pagination color="#27AB9C" v-model="pageNumber" :length="pageMax" :total-visible="7" @input="pageChange"></v-pagination>
        </v-row>
      </v-card-text>
    </v-card>
      <!-- dialog comfirm delete -->
    <v-dialog  v-model="dialogConfirmDelete" width="400" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">{{ dialogTitile }}</font></span>
          <v-btn icon dark @click="dialogConfirmDelete = false">
            <v-icon color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br/><br/>
        <v-card-text >
          <span>คุณต้องการ{{ dialogTitile }}นี้ ใช่หรือไม่ ?</span>
        </v-card-text>
        <v-card-actions >
      <v-container >
        <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="closeConfirmDelete()">ยกเลิก</v-btn>
        <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="deleteData()">ตกลง</v-btn>
      </v-container>
      </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalManageCustomerData ref="ModalManageCustomerData" />
    <ModalManageCustomerAddress ref="ModalManageCustomerAddress" />
  </v-container>
</template>
<script>
import { Decode } from '@/services'
import moment from 'moment'
export default {
  components: {
    ModalManageCustomerData: () => import('@/components/Gracz/Admin/Customer/Modal/ManageCustomerDataModal'),
    ModalManageCustomerAddress: () => import('@/components/Gracz/Admin/Customer/Modal/ManageCustomerAddressModal')
  },
  data () {
    return {
      pageCount: 5,
      pageMax: null,
      current: 1,
      pageSize: 5,
      itemsPerPage: 10,
      customerDetail: {},
      customerId: null,
      dialogConfirmDelete: false,
      addressList: [],
      dialogTitile: '',
      editAdressId: null,
      totalAddress: 0
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push(`/Order/CustomerDetailMobile?cusid=${this.customerId}`).catch(() => {})
      } else {
        this.$router.push(`/Order/CustomerDetail?cusid=${this.customerId}`).catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    },
    pageNumber: {
      get () {
        return this.current || 1
      },
      set (newPage) {
        // You could alternatively call your API here if you have serverside pagination
        this.current = newPage
      }
    },
    indexStart () {
      return (this.current - 1) * this.pageSize
    },
    indexEnd () {
      return this.indexStart + this.pageSize
    },
    paginated () {
      return this.addressList.slice(this.indexStart, this.indexEnd)
    }
  },
  mounted () {
    this.$EventBus.$on('getCustomerDetail', this.getData)
    this.$EventBus.$on('getAddressCustomer', this.getCustomerAddress)
    this.$on('hook:beforeDestroy', () => {
      this.$EventBus.$off('getCustomerDetail')
      this.$EventBus.$off('getAddressCustomer')
    })
  },
  created () {
    window.scrollTo(0, 0)
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      }
      this.customerId = this.$route.query.cusid
      this.getData()
      this.getCustomerAddress()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push('/Order/CustomerListMobile').catch(() => {})
      } else {
        this.$router.push('/Order/CustomerList').catch(() => {})
      }
    },
    async getData () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        cus_id: parseInt(this.customerId)
      }
      await this.$store.dispatch('actionsGraczCustomerDetail', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczCustomerDetail
      if (response.message === 'Get detail customer success.') {
        this.$store.commit('closeLoader')
        if (response.data.length !== 0) {
          this.customerDetail = response.data[0]
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getCustomerAddress () {
      window.scrollTo(0, 0)
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      var page = this.addressList.length === 1 ? this.pageMax - 1 : this.pageNumber
      this.pageNumber = page
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        cus_id: parseInt(this.customerId),
        page: this.pageNumber
      }
      await this.$store.dispatch('actionsGraczGetListCustomerAddress', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczGetListCustomerAddress
      if (response.message === 'Get list customer address successfully.') {
        this.$store.commit('closeLoader')
        if (response.data.length !== 0) {
          this.addressList = response.data.address
        }
        this.page = this.pageMax
        this.totalAddress = response.data.total_address
        this.pageMax = parseInt(this.totalAddress / 5) === 0 ? 1 : Math.ceil(this.totalAddress / 5)
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    pageChange (page) {
      console.log('page', this.page)
      console.log('pageNumber', this.pageNumber)
      this.pageNumber = page
      this.page = this.pageMax
      this.getCustomerAddress()
    },
    editCustomer () {
      this.$refs.ModalManageCustomerData.open('แก้ไขข้อมูลลูกค้า')
    },
    closeConfirmDelete () {
      this.dialogConfirmDelete = false
    },
    deleteData () {
      if (this.dialogTitile === 'ลบข้อมูลลูกค้า') {
        this.deleteCustomer()
      } else {
        this.deleteAddressCustomer()
      }
    },
    confirmDelete () {
      this.dialogTitile = 'ลบข้อมูลลูกค้า'
      this.dialogConfirmDelete = true
    },
    async deleteCustomer () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        cus_id: parseInt(this.customerId)
      }
      await this.$store.dispatch('actionsGraczDeleteCustomer', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczDeleteCustomer
      if (response.message === 'Delete customer successfully.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'success', text: 'ลบข้อมูลลูกค้าสำเร็จ', showConfirmButton: false, timer: 2000 })
        this.$EventBus.$emit('getCustomerList')
        this.closeConfirmDelete()
        this.backtoMenu()
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    confirmDeleteAddress (item) {
      this.editAdressId = item.address_id
      this.dialogTitile = 'ลบข้อมูลที่อยู่จัดส่ง'
      this.dialogConfirmDelete = true
    },
    async deleteAddressCustomer () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        cus_id: parseInt(this.customerId),
        address_id: this.editAdressId
      }
      await this.$store.dispatch('actionsGraczDeleteCustomerAddress', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczDeleteCustomerAddress
      if (response.message === 'Delete customer address successfully.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'success', text: 'ลบข้อมูลที่อยู่จัดส่งสำเร็จ', showConfirmButton: false, timer: 2000 })
        this.closeConfirmDelete()
        this.getData()
        this.getCustomerAddress()
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    addAddress () {
      var item
      this.$refs.ModalManageCustomerAddress.open('เพิ่มที่อยู่จัดส่ง', item)
    },
    editAddress (item) {
      this.$refs.ModalManageCustomerAddress.open('แก้ไขที่อยู่จัดส่ง', item)
    },
    formatDateTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else if (msg === 'Customer address not found.') {
        return ['ไม่พบที่อยู่ลูกค้า', 'warning']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>
<style scoped>
.text-value {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.fontSizeDetail {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.fontSizeDetailMobile {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.fontSizeTitle {
  font-weight: 700;
  font-size: 20px;
  color: #333333;
}
.fontSizeTitleMobile {
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  color: #333333;
}
.font16_msgNoAddress {
  font-size: 16px; font-weight: 400; line-height: 24px; color: #F5222D; text-align: center !important;
}
</style>
